import type { ElementType, ReactNode } from 'react';
import styles from './Card.module.css';

interface ICardProps {
  as?: ElementType;
  className?: string;
  children: ReactNode;
  refreshing?: boolean; // Showing the previous timeframe's content while the new one loads.
  'aria-busy'?: boolean | 'true' | 'false';
  'aria-label'?: string;
}

/**
 * Shared surface for the Productivity cards — the white panel shell
 * (padding, border, radius, shadow). Card-specific layout stays in each
 * consumer's own module via `className`.
 */
export function Card({ as: Tag = 'section', className, children, refreshing = false, ...aria }: ICardProps) {
  return (
    <Tag
      className={[styles.card, refreshing && styles.refreshing, className].filter(Boolean).join(' ')}
      aria-busy={refreshing || undefined}
      {...aria}
    >
      {children}
    </Tag>
  );
}
